const toolBar ={
    HOMEPAGE:null,
    show:false,
    globalSearch:null,
    qcdata:null,
    searchboxcnt:false,
    searchupdatedata:{
        lat: 20.5937,
        lng: 78.9629
    }
 }
 const reducer = (state = toolBar,action) => {
     if(action.type === 'MENU'){
         return {
             ...state,
             show:action.value
         };
     }else if(action.type === 'SEARCH'){
         return{
            ...state,
            globalSearch:action.value
         }
     }else if(action.type === 'QUICKLINK'){
        return{
            ...state,
            qcdata:action.value
         }
     }else if(action.type === 'REFRESH'){
        return{
            ...state,
            refresh:action.value
         }
     }
     else if(action.type === 'ONLYREFRESH'){
        return{
            ...state,
            onlyrefresh:action.value
         }
     }
     else if(action.type === 'MENULIST'){
        return{
            ...state,
            menulist:action.value
         }
     }else if(action.type === 'SEARCHBOXCNT'){
        return{
            ...state,
            searchboxcnt:action.value
         }
     }
     else if(action.type === 'searchupdatedata'){
        return{
            ...state,
            searchupdatedata:action.value
         }
     }
     else if(action.type === 'searchdealerpoint'){
        return{
            ...state,
            searchdealerpoint:action.value
         }
     }    
     else if(action.type === 'HOMEPAGE'){
        return{
            ...state,
            HOMEPAGE:action.value
         }
     } 
     return {...state};
 };
 
 export default reducer;